module.exports = __webpack_public_path__ + "static/media/Lacnic.91edf050.svg";